export enum DashboardEnum {
    Sharelog = 1,
    Netvote = 2,
    GeneralMeeting = 4
}
